import { Button } from "@mui/material";
import { useState } from "react";
import { useLoaderData } from "react-router-dom";

import useService from "../../../../hooks/useService";
import ApiRequestErrorHandler from "../../../global/ApiRequestErrorHandler";
import ResponseModal from "../../../global/ResponseModal";
import HNSColors from "../../../ui library/HNSColors";

export default function DownloadButton({ isDownloadAllDocs, selectedDocuments }) {
  const label = isDownloadAllDocs ? "Download All Documents" : "Download Selected Documents";
  const exportAllRepository = useService("repositories/export-all-repository");

  const [openErrorModal, setOpenErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const [successMessage, setSuccessMessage] = useState("");
  const [openSuccessModal, setOpenSuccessModal] = useState(false);

  const { _case } = useLoaderData();

  const onClickDownloadDoc = async () => {
    try {
      const payload = { id: _case?.id };
      const param = isDownloadAllDocs ? false : selectedDocuments;
      const response = await exportAllRepository.export(payload, param);

      setSuccessMessage(response?.message);
      setOpenSuccessModal(true);
    } catch (error) {
      setOpenErrorModal(true);
      const res = error;
      const errArr = ApiRequestErrorHandler(res);
      setErrorMessage(errArr);
    }
  };

  return (
    <>
      <Button
        variant="outlined"
        onClick={onClickDownloadDoc}
        size="small"
        style={{ width: "15rem" }}
        sx={{
          padding: "10px 18px",
          borderRadius: "999px",
          textTransform: "none",
          backgroundColor: HNSColors.neutrals[900],
          borderColor: HNSColors.secondary[400],
          color: HNSColors.secondary[400],
          "&:hover": {
            backgroundColor: HNSColors.secondary[900],
            borderColor: "transparent",
            color: HNSColors.secondary[400],
          },
        }}
      >
        {label}
      </Button>
      <ResponseModal
        title="Documents Requested"
        description={successMessage}
        openBool={openSuccessModal}
        setOpenBool={setOpenSuccessModal}
      />
      <ResponseModal
        title="Error"
        isError={true}
        openBool={openErrorModal}
        setOpenBool={setOpenErrorModal}
        errorMessage={errorMessage}
      />
    </>
  );
}
